import { createFileRoute, notFound } from "@tanstack/react-router";
import guidesStyles from "../styles/guides.css?url";
import { withStylesheet } from "../lib/head";
import { loadGuide } from "../platform/guides";
import { GuidePage } from "../platform/guides/guides-pages";
import { platformPageHead, platformShellFrom } from "../platform/head";

/** One guide (/guides/<slug>), with its Article, breadcrumb and FAQ structured data. */
export const Route = createFileRoute("/guides/$slug")({
  loader: async ({ params }) => {
    const page = await loadGuide({ data: params.slug });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: loaderData.path,
            title: `${loaderData.title} | Drate`,
            description: loaderData.description,
            canonicalPath: loaderData.path,
            image: loaderData.cover.src,
            imageSize: [loaderData.cover.width, loaderData.cover.height],
            imageAlt: loaderData.cover.alt,
            article: true,
            structuredData: loaderData.structuredData,
          }),
          guidesStyles,
        )
      : {},
  component: () => <GuidePage page={Route.useLoaderData()} />,
});
